import { useNavigate } from 'react-router-dom';
import { Layout as PageLayout } from 'modules/app/components/templates/generic-page-layout/Layout';

export const ErrorPage = () => {
  const displayTitle = 'Sorry, there was an error loading this page. Please try again later.';
  const displayMessage =
    "This doesn't mean we can't help you find a solution for your financial future.";

  const navigate = useNavigate();
  const goHome = () => {
    navigate('/');
  };

  return (
    <PageLayout
      title={displayTitle}
      subtitle={displayMessage}
      buttons={[
        {
          title: 'Go home',
          onClick: async () => goHome()
        }
      ]}
    />
  );
};
